import React from 'react';
import { useSelector } from 'react-redux';
import {
  isDrawMode,
  isSelectionModeActive,
  getSelectionTool,
  selectionTools,
} from "../../redux/objectSelection";
import { colors } from "../../utils/colors";

const RectangleUI = () => {
  const isDrawActive = useSelector((state) => isDrawMode(state));
  const isSelectionActive = useSelector((state) =>
    isSelectionModeActive(state, "windows")
  );
  const selectionTool = useSelector((state) => getSelectionTool(state));

  const rectangleUI = useSelector((state) => state.objectSelection.rectangleUI);
  if (
    !isDrawActive ||
    !isSelectionActive ||
    !rectangleUI.isDrawing ||
    !rectangleUI.startPoint ||
    !rectangleUI.currentPoint
  )
    return null;

  const { startPoint, currentPoint } = rectangleUI;

  const left = Math.min(startPoint.x, currentPoint.x);
  const top = Math.min(startPoint.y, currentPoint.y);
  const width = Math.abs(currentPoint.x - startPoint.x);
  const height = Math.abs(currentPoint.y - startPoint.y);

  const drawStyle = {
    border: `2px dashed ${colors.orange500()}`,
    backgroundColor: `${colors.orange500()}30`,
    boxShadow: `0 0 10px ${colors.orange500()}`,
  };

  const eraseStyle = {
    border: `2px dashed ${colors.gray400()}`,
    backgroundColor: `${colors.gray400()}30`,
    boxShadow: `0 0 10px ${colors.gray400()}`,
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 998,
      }}
    >
      <div
        style={{
          position: "absolute",
          left: `${left}px`,
          top: `${top}px`,
          width: `${width}px`,
          height: `${height}px`,
          pointerEvents: "none",
          zIndex: 1000,
          borderRadius: "4px",
          ...(selectionTool === selectionTools.DRAW ? drawStyle : eraseStyle),
        }}
      />
    </div>
  );
};

export default RectangleUI;
